module.exports = __webpack_public_path__ + "static/img/8areaA_12.396bcc0.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/8areaA_12.png
// module id = 1057
// module chunks = 1